/**
 * 本地缓存数据 读取操作 的代理对象
 * 封装底层存储系统（Cookie,localStorage,SessionStorage）的读取操作
 */
import { getCookie } from 'utils';

class DataStore {
  storageTest(storage) {
    if (storage) {
      try {
        storage.setItem('key', 'value');
        storage.removeItem('key');
        return true;
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }
  }

  setStorage(key, value, type, expires) {
    const { storageTest } = this;
    switch (type) {
      case 'cookie':
        document.cookie = `${key}=${escape(value)};${expires ? `expires =${expires}` : ''}`;
        break;
      case 'localStorage':
        if (storageTest(localStorage)) {
          localStorage.setItem(key, JSON.stringify(value));
        }
        break;
      case 'sessionStorage':
        if (storageTest(sessionStorage)) {
          sessionStorage.setItem(key, JSON.stringify(value));
        }
        break;
      default:
        if (storageTest(localStorage)) {
          sessionStorage.setItem(key, JSON.stringify(value));
        }
    }
  }


  getStorage(key, type) {
    const { storageTest } = this;
    if (type === 'cookie') {
      return getCookie(key);
    } else if (type === 'localStorage') {
      if (storageTest(localStorage)) {
        const val = localStorage.getItem(key);
        return val ? JSON.parse(val) : null;
      }
      return null;
    }
    if (storageTest(sessionStorage)) {
      const val = sessionStorage.getItem(key);
      if (val) {
        return JSON.parse(val);
      }
      return null;
    }
    return null;
  }

  setNowPage(val) {
    this.setStorage('nowPage', val);
  }

  getNowPage() {
    return this.getStorage('nowPage');
  }

  setPrePage(val) {
    this.setStorage('prePage', val);
  }

  getPrePage() {
    return this.getStorage('prePage');
  }

  setSessionId(val) {
    this.setStorage('sessionId', val, 'localStorage');
  }

  getSessionId() {
    return this.getStorage('sessionId', 'localStorage');
  }

  setFixedUploadParams(val) {
    this.setStorage('fixedUploadParams', val);
  }

  getFixedUploadParams() {
    return this.getStorage('fixedUploadParams');
  }

  setPageVisitiLog(action) {
    const nowPage = this.getNowPage();
    const oldObj = this.getPageVisitiLog(nowPage);
    const obj = {
      startVisitTime: new Date().getTime(), // 每次进入页面的开始时间
      page: nowPage,
      hasAnyAction: (oldObj && oldObj.hasAnyAction) ? true : action, // 如果是true 则只会写入一次 表示该页面永远有了操作
    };
    this.setStorage(`${nowPage}_visitlog`, obj);
  }

  getPageVisitiLog(page) {
    return this.getStorage(`${page}_visitlog`);
  }
}


// 作为一个工具对象，使用单例模式
export default new DataStore();
